<template>
    <div class="mb-update">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" right-text="保存" @click-right="updateMember"
                     left-arrow :fixed="true">
        </van-nav-bar>
        <div style="height: 100%;background-color: #FFFFFF">
            <van-cell-group v-if="type=='nc'">
                <van-field v-model="memberName" placeholder="请输入昵称"/>
            </van-cell-group>
            <van-cell-group v-if="type=='sr'" @click="dateClick">
                <van-cell is-link>
                    {{srDate}}
                </van-cell>
            </van-cell-group>
            <van-cell-group v-if="type=='sjh'">
                <van-field v-model="phone" placeholder="请输入手机号"/>
            </van-cell-group>
        </div>

        <van-popup v-model="showPicker" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    :max-date="maxDate"
                    @confirm="onConfirm"
                    @cancel="showPicker = false"/>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";

    export default {
        data() {
            return {
                title: '设置信息',
                deptId: '',
                token: '',
                memberId: '',
                type: '',
                memberName: '',
                srDate: '',
                phone: '',
                showPicker: false,
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(),
                currentDate: new Date()
            };
        },
        async created() {
            document.title = getDeptName()
            this.memberId = this.$route.params.mid
            this.type = this.$route.params.type
            if (this.type == 'nc') {
                if (this.$route.params.val == null) {
                    this.memberName = ''
                } else {
                    this.memberName = this.$route.params.val
                }
            }
            if (this.type == 'sr') {
                if (this.$route.params.val == 'null') {
                    this.srDate = '请选择生日'
                } else {
                    this.srDate = this.$route.params.val
                }
            }
            if (this.type == 'sjh') {
                if (this.$route.params.val == null) {
                    this.phone = ''
                } else {
                    this.phone = this.$route.params.val
                }
            }

            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
        },
        methods: {
            dateClick() {
                this.showPicker = true
                this.minDate = new Date(1990, 0, 1)
                this.maxDate = new Date()
            },
            onConfirm(val) {
                var year = val.getFullYear();     //获取年份
                var month = val.getMonth() + 1;    //获取月份
                var day = val.getDate();          //获取日期
                var yyyymmdd = year + "-" + month + "-" + day;  //拼接成yyyymmdd形式字符串
                this.srDate = yyyymmdd
                this.showPicker = false
            },

            async updateMember() {
                let data = {
                    id: this.memberId
                }
                if (this.type == 'nc') {
                    data.memberName = this.memberName
                    if (!this.memberName) {
                        this.$notify({
                            message: "请输入昵称",
                            duration: 1000,
                            background: 'red'
                        });
                        return;
                    }
                }
                if (this.type == 'sr') {
                    data.dateStr = this.srDate
                    if (!this.srDate) {
                        this.$notify({
                            message: "请选择生日",
                            duration: 1000,
                            background: 'red'
                        });
                        return;
                    }
                }
                if (this.type == 'sjh') {
                    if (!this.phone) {
                        this.$notify({
                            message: "请输入手机号",
                            duration: 1000,
                            background: 'red'
                        });
                        return;
                    }
                    var strTemp = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
                    let b = strTemp.test(this.phone)
                    if (!b) {
                        this.$notify({
                            message: "请输入正确的手机号",
                            duration: 1000,
                            background: 'red'
                        });
                        return;
                    }
                    data.phone = this.phone
                }
                let res = await this.$post("/spm/updateSpmMember", data)
                if (res.code == 200) {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                    this.onClickLeft()
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },
            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>

    .mb-update {
        margin: 0 auto;
        height: 100%;
        position: relative;
        background-color: #EEEEEE;
        padding-top: 50px;
    }

    ::v-deep .van-field__control {
        display: block;
        box-sizing: border-box;
        width: 100%;
        min-width: 0;
        margin: 0;
        padding: 0;
        color: #323233;
        line-height: inherit;
        text-align: left;
        background-color: transparent;
        border: 0;
        resize: none;
        border-bottom: #dddddd solid 1px;
    }

</style>
